import Checkbox from "./Checkbox";
import DatePicker from "./DatePicker";
import NumberInput from "./NumberInput";
import Password from "./Password";
import PhoneNumber from "./PhoneNumber";
import SelectList from "./SelectList";
import TextArea  from "./TextArea";
import TextInput from "./TextInput";
import Age from "./Age";
import Address from "./AddressInput";
import FileUpload from "./FileUpload";
import MultiSelectDropDown from "./MultiSelectDropDown";
import Blank from "./Blank";
import NonEditInput from "./NonEditInput";
import SelectListWithSearch from "./SelectListWithSearch";
import TimePicker from "./TimePicker";
import RadioGroup from "./RadioGroup";
import RadioButton from "./RadioButton";
import DecimalInput from "./Decimal";
import YesOrNoFields from "./YesOrNoFields";
import Tags from "./Tags";
import RichTextEditor from "./RichtextEditor/RichTextEditor";
import Signature from './Signature';
import ZipCodeInput from "./ZipCodeInput";
import ImageUpload from "./ImageUpload";
import { useEffect } from "react";
import FileType from "./FileType";
import Buttons from "../Buttons";
import CheckboxDropDown from "./CheckboxDropDown";
import SelectSearchFields from "./SelectSearchFields";
import SymbolsOnlyInput from "./SymbolsOnlyInput ";
import NewSignature from "./NewSignature";
import NewDatePicker from "./NewDatePicker";
import NewNumberInput from "./NewnumberInput";
import NewDecimalInput from "./NewDecimal";
import VisionNumberInput from "./TagInput/VisionNumberInput";
import NewTextInput from "./NewTextInput";
import NewSelectListWithSearch from "./NewSelectListWithSearch";
import NewSelectList from "./NewSelectList";
import NewTextArea from "./NewTextArea";

 const FormInputs = (props) => {
  const {type} = props;
 switch (type) {
    case "TextInput":
      return <TextInput {...props} />;
    case "NewTextInput":
      return <NewTextInput {...props} />;
    case "Decimal":
      return <DecimalInput {...props} />
    case "NewDecimal":
      return <NewDecimalInput {...props} />
    case "Checkbox":
        return <Checkbox {...props} />;
    case "Password":
      return <Password {...props} />;
    case "SelectList":
      return <SelectList {...props} />;
    case "NewSelectList":
      return <NewSelectList {...props} />;
    case "MultiSelectList":
      return <SelectList {...props} />;
    case "Date":
      return <DatePicker {...props} />;
    case "NewDate":
      return <NewDatePicker {...props} />;
    case "Phone":
      return <PhoneNumber {...props} />;
    case 'TextArea':
        return <TextArea {...props}/> ;
    case 'NewTextArea':
        return <NewTextArea {...props}/> ;
    case 'Number':
        return <NumberInput {...props}/> ;
    case 'NewNumber':
        return <NewNumberInput {...props}/> ;
    case 'VisionNumber':
        return <VisionNumberInput {...props}/> ;
    case 'MultiSelectDropDown':
      return <MultiSelectDropDown {...props} />
    case 'Tag':
        return <Tags {...props}/> ;
    case 'Age':
        return <Age {...props}/> ;
    case 'Address':
        return <Address {...props}/> ;
    case 'FileUpload':
        return <FileUpload {...props} />;
    case 'SelectSearchList':
        return <SelectListWithSearch {...props} />;
    case 'NewSelectSearchList':
      return <NewSelectListWithSearch {...props} />;
    case 'Blank':
        return <Blank {...props}/>
    case 'NonEdit':
        return <NonEditInput {...props}/>;
    case 'Time':
        return <TimePicker {...props}  />
    case 'Radio':
        return <RadioButton {...props} />
    case 'RadioGroup':
        return <RadioGroup {...props} />
    case 'YesOrNo':
          return <YesOrNoFields {...props} />
    case 'Editor':
      return <RichTextEditor {...props}/>;
    case 'Signature':
      return <Signature {...props}/>
    case 'NewSignature':
      return <NewSignature {...props}/> 
    case 'ZipCode':
      return <ZipCodeInput  {...props}/>
    case 'ImageUpload':
      return <ImageUpload  {...props}/>
   case 'FileType':
     return <FileType  {...props} />
   case 'Button':
     return <Buttons  {...props} />
   case 'CheckboxDropDown':
    return <CheckboxDropDown {...props}/>  
   case 'SelectSearchFields':
        return <SelectSearchFields {...props} />; 
    case 'SymbolsOnly':
        return <SymbolsOnlyInput {...props} />;
    default:
      return <TextInput {...props} />;
  }
};

export default FormInputs;